import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { List, ListItem, ListItemText, Checkbox, FormControlLabel } from '@mui/material';
import { SetStateAction } from 'react';
import {
  composableDashboardFiltersLabelValue,
  ComposableDashboardFiltersEnum,
  IComposableDashboardFiltersContext,
} from 'wisestep-api';
import { WsDrawer } from 'wisestep-base';

import { useComposableDashboardsFiltersContext } from '../../hooks/useComposableDashboardsFiltersContext';
import StyledButton from '../StyledButton';

import SmartFiltersOption from './SmartFiltersOptions';

const FilterSelectionDrawer = ({
  openFilterSelectionDrawer,
  setOpenFilterSelectionDrawer,
  onAdd,
  onRemove,
}: {
  onAdd: (filter: ComposableDashboardFiltersEnum) => void;
  onRemove: (filter: ComposableDashboardFiltersEnum) => void;
  openFilterSelectionDrawer: boolean;
  setOpenFilterSelectionDrawer: (value: SetStateAction<boolean>) => void;
}) => {
  const { filtersAdddedToDashboard, dependentFilters, setDependentFilters } =
    useComposableDashboardsFiltersContext() as Required<IComposableDashboardFiltersContext>;
  return (
    <WsDrawer
      open={openFilterSelectionDrawer}
      onClose={() => setOpenFilterSelectionDrawer(false)}
      size="small"
      title="Add Filters"
    >
      <List sx={{ width: '100%', bgcolor: 'background.paper', px: 4, py: 2 }}>
        {Object.keys(composableDashboardFiltersLabelValue).map((filterEnum) => (
          <ListItem
            key={filterEnum}
            disableGutters
            sx={{ borderBottom: '1px solid black', marginTop: '2px' }}
            secondaryAction={
              <>
                {(filtersAdddedToDashboard as ComposableDashboardFiltersEnum[]).filter(
                  (addedFilter) => addedFilter === filterEnum
                ).length > 0 ? (
                  <>
                    {(filterEnum as ComposableDashboardFiltersEnum) ==
                      ComposableDashboardFiltersEnum.DATE_RANGE && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={dependentFilters?.['singleDateField']}
                            onChange={({ target }) =>
                              setDependentFilters((d) => ({
                                ...d,
                                singleDateField: target.checked,
                              }))
                            }
                          />
                        }
                        label="Single Field"
                      />
                    )}
                    <StyledButton
                      variant="text"
                      size="small"
                      startIcon={<RemoveCircleIcon />}
                      remove={true}
                      onClick={() => onRemove(filterEnum as ComposableDashboardFiltersEnum)}
                    >
                      Remove
                    </StyledButton>
                  </>
                ) : (
                  <StyledButton
                    remove={false}
                    variant="text"
                    size="small"
                    startIcon={<AddCircleOutlinedIcon />}
                    onClick={() => onAdd(filterEnum as ComposableDashboardFiltersEnum)}
                  >
                    Add
                  </StyledButton>
                )}
              </>
            }
          >
            <ListItemText primary={composableDashboardFiltersLabelValue[filterEnum].label} />
          </ListItem>
        ))}
        <SmartFiltersOption />
      </List>
    </WsDrawer>
  );
};

export default FilterSelectionDrawer;
